import { Translation } from '@ps/web-shared-components';
import React from 'react';

import { useRegulatoryIntl } from '@swf/core/hooks/useRegulatoryIntl';
import { Icon } from '@swf/sports/components';

import { TXTWCL_odds_boost } from './OddsBoostPanelHeader.messages.json';
import styles from './OddsBoostPanelHeader.scss';

export const OddsBoostPanelHeader: React.FC = () => {
  const { formatMessage } = useRegulatoryIntl();
  return (
    <header className={styles.oddsBoostHeader}>
      <span className={styles.oddsBoostTitle}>
        <Icon size="lg" name="price-boost" label={formatMessage(TXTWCL_odds_boost)} />
        <span className={styles.oddsBoostTitleText}>
          <Translation {...TXTWCL_odds_boost} />
        </span>
      </span>
    </header>
  );
};
